const _Swiper = Swiper || {}

const findMatchingSlide = (slides, featuredSrc) => {
    return slides.find(slide => {
        const img = slide.querySelector('img');

        if (img) {
            const absoluteImgSrc = new URL(img.src).href.replace(/_\d+x/, '')
            const absoluteFeaturedSrc = new URL(featuredSrc, window.location.href).href.replace(/_\d+x/, '')

            return absoluteImgSrc === absoluteFeaturedSrc
        }
        return false
    });
};

function standardizeString(str) {
    return str
        .toLowerCase()
        .replace(/\|.*/, "")
        .replace(/\(.*?\)/g, "")
        .trim();
}

class productMediaNew extends HTMLElement {
    constructor() {
        super()
        this.boundReInitSwiper = this.reInitSwiper.bind(this)
        this.initConfigs();
        // Initialize the thumbnail Swiper first
        this.thumbnailSwiperInstance = new _Swiper(this.queryElement('[data-product-media-new-thumbnail-swiper]'), this.thumbnailConfig)
        this.initSwiper()
        this.thumbnailPurgatory = this.queryElement('[data-product-media-new-thumbnail-purgatory]');
        this.mediaPurgatory = this.queryElement('[data-product-media-new-media-purgatory]');
    }

    queryElement(selector) {
        return this.querySelector(selector);
    }

    initConfigs() {

        // Thumbnails Swiper config
        this.thumbnailConfig = {
            direction: 'vertical',
            slidesPerView: 6,
            spaceBetween: 20,
            watchSlidesVisibility: true,
            autoHeight: true,
            navigation: {
                nextEl: '[data-product-media-new-thumbnail-swiper-next]',
                prevEl: '[data-product-media-new-thumbnail-swiper-prev]',
            }
        }

        // Main Swiper config
        this.mainConfig = {
            slidesPerView: 'auto',
            spaceBetween: 1, // this needs to be 1 or the next image peeks through for some reason
            loop: false,
            pagination: {
                el: '[data-product-media-swiper-pagination]',
                clickable: true,
                type: 'custom',
                renderCustom(_, current, total) {
                    return (`
                              ${current}/${total}
                          `)
                }
            },
            navigation: {
                nextEl: '[data-product-media-new-swiper-next]',
                prevEl: '[data-product-media-new-swiper-prev]',
            },
            breakpoints: {
                750: {
                    pagination: {
                        el: null
                    },
                    navigation: {
                        nextEl: null,
                        prevEl: null
                    }
                }
            },
            thumbs: {
                swiper: this.thumbnailSwiperInstance
            }
        }
    }

    connectedCallback() {
        this.initListeners()
    }

    disconnectedCallback() {
        this.removeListeners()
    }

    initSwiper() {
        this.thumbnailSwiperInstance = new _Swiper(this.queryElement('[data-product-media-new-thumbnail-swiper]'), this.thumbnailConfig)
        this.mainConfig.thumbs = { swiper: this.thumbnailSwiperInstance }
        this.swiperInstance = new _Swiper(this.queryElement('[data-product-media-new-swiper]'), this.mainConfig)
    }

    reInitSwiper() {

        let activeIndex = 0
        if (this.swiperInstance) {
            activeIndex = this.swiperInstance.activeIndex
            this.swiperInstance.destroy(true, true)
        }

        if (this.thumbnailSwiperInstance) {
            this.thumbnailSwiperInstance.destroy(true, true)
        }

        this.initSwiper()

        this.swiperInstance.slideTo(activeIndex)
    }

    removeListeners() {
        window.removeEventListener('resize', this.boundReInitSwiper)
    }

    handleVariantUpdated(event) {
        const hasSwatchesText = this.queryElement('[data-product-media-new-swiper]').dataset.productHasSwatches || 'false';
        const hasSwatches = hasSwatchesText.trim().toLowerCase() === 'true';
        if (hasSwatches) {
            this.handleSwatches(event);
        } else {
            this.handleNoSwatches(event);
        }
    }

    handleSwatches(event) {
        const variant = event.detail.variant

        // Get all slides, including those in the purgatory
        const allSlides = Array.from(this.mediaPurgatory.children).concat(Array.from(this.swiperInstance.slides))
        const allThumbnails = Array.from(this.thumbnailPurgatory.children).concat(Array.from(this.thumbnailSwiperInstance.slides))
        
        allSlides.sort((a, b) => {{
           return +a.dataset.index - +b.dataset.index;
        }})

        allThumbnails.sort((a, b) => {{
              return +a.dataset.index - +b.dataset.index;
        }})

        const matchingSlides = allSlides.filter(slide => {
            const img = slide.querySelector('img')
            if (!img) { return false }

            const replacedVariantTitle = standardizeString(variant.title)
            const trimmedAltTag = standardizeString(img.alt || 'noAlt')

            if (trimmedAltTag === 'all') {
                return true
            }

            return img && trimmedAltTag === replacedVariantTitle
        })

        const validIndexes = matchingSlides.length > 0 ?
            matchingSlides.map(slide => slide.dataset.mediaPosition) : allSlides.map(slide => slide.dataset.mediaPosition)

        allThumbnails.forEach(thumbnail => {
            const index = thumbnail.dataset.mediaPosition
            if (validIndexes.includes(index)) {
                this.thumbnailSwiperInstance.el.querySelector('.swiper-wrapper').appendChild(thumbnail)

            } else {
                this.thumbnailPurgatory.appendChild(thumbnail)
            }
        })

        allSlides.forEach(slide => {
            const index = slide.dataset.mediaPosition
            if (validIndexes.includes(index)) {
                this.swiperInstance.el.querySelector('.swiper-wrapper').appendChild(slide)  
            } else {
                this.mediaPurgatory.appendChild(slide)

            }
        })


        this.swiperInstance.update()
        this.thumbnailSwiperInstance.update()
        this.swiperInstance.slideTo(0)
    }

    handleNoSwatches(event) {
        const variant = event.detail.variant;
        const slides = Array.from(this.swiperInstance.slides);

        if (variant && variant.featured_image && variant.featured_image.src) {
            const featuredSrc = variant.featured_image.src;
            const matchingSlide = findMatchingSlide(slides, featuredSrc);

            if (matchingSlide) {
                const index = slides.indexOf(matchingSlide);
                this.swiperGoTo(index);
            }
        }
    }

    swiperGoTo(index) {
        this.swiperInstance.slideTo(index);
    }

    initListeners() {
        if (matchMedia("(min-width: 768px)").matches) {
            window.addEventListener('resize', this.boundReInitSwiper)
        }
        window.addEventListener('variantUpdated', this.handleVariantUpdated.bind(this))
    }
}

customElements.define('product-media-new', productMediaNew)